import { getUrlWithBasePath } from '@lib/utils';
import { memo } from 'react';

function MainnetBackground() {
  return (
    <div className="relative h-3/5 w-full">
      <img
        alt="bg-bottom-left"
        src={getUrlWithBasePath('/assets/images/bg-bottom-left.svg')}
        className="absolute top-[386px] left-[-40px] tablet:left-[140px] animate-bg-bounce-fast brightness-200"
      />
      <img
        alt="bg-left-upper"
        src={getUrlWithBasePath('/assets/images/bg-left-upper.svg')}
        className="absolute top-[0px] left-[-40px] tablet:left-[72px] animate-bg-bounce brightness-200"
      />
      <img
        alt="bg-left-lower"
        src={getUrlWithBasePath('/assets/images/bg-left-lower.svg')}
        className="absolute top-[261px] left-[30px] tablet:left-[225px] animate-bg-bounce brightness-200"
      />
      <img
        alt="bg-bottom-right"
        src={getUrlWithBasePath('/assets/images/bg-bottom-right.svg')}
        className="absolute top-[236px] right-[-90px] animate-bg-bounce brightness-200"
      />
      <img
        alt="bg-right-lower"
        src={getUrlWithBasePath('/assets/images/bg-right-lower.svg')}
        className="absolute top-[98px] right-0 tablet:right-[245px] animate-bg-bounce brightness-200"
      />
      <img
        alt="bg-right-upper"
        src={getUrlWithBasePath('/assets/images/bg-right-upper.svg')}
        className="absolute top-[21px] right-[20px] tablet:right-[300px] animate-bg-bounce-fast brightness-200"
      />
    </div>
  );
}

export default memo(MainnetBackground);
